import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Divider } from '../../../../Divider/Divider';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const offerToggleRootClassName = css`
  margin-top: 16px;
`;

export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
  gap: 24px;
`;

export const DividerStyled = styled(Divider)`
  margin: 16px 0;
`;

export const dividerClassName = css`
  margin: 16px 0;
`;

export const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;
